import { SafetyFacilityType, SpfExportTypes } from "./SPFConstants";
import * as twoLaneRuralSPFs from "./twoLaneRuralSPFs";
import * as multiLaneRuralSPFs from "./multiLaneRuralSPFs";
import * as urbanSubArtSPFs from "./UrbanSubArtSPFs";
import * as urbanSubColSPFs from "./UrbanSubColSPFs";
import * as rampTerminalSPFs from "./rampTerminal/rampTerminalSPFs";

export const getSpfsForFacilityType = (
  facilityType: SafetyFacilityType
): SpfExportTypes => {
  const FACILITY_TYPE_TO_SPFS = {
    [SafetyFacilityType.TWO_LANE_RURAL_ROADWAY]: twoLaneRuralSPFs,
    [SafetyFacilityType.RURAL_MULTILANE_HIGHWAY]: multiLaneRuralSPFs,
    [SafetyFacilityType.URBAN_SUBURBAN_ARTERIAL]: urbanSubArtSPFs,
    [SafetyFacilityType.URBAN_SUBURBAN_COLLECTOR]: urbanSubColSPFs,
    [SafetyFacilityType.RAMP_TERMINAL]: rampTerminalSPFs,
  };
  const spfs = FACILITY_TYPE_TO_SPFS[facilityType];
  if (spfs) {
    return spfs;
  }
  throw new Error(
    `Safety Performance Functions not found for facility type: ${facilityType}`
  );
};
